import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	alive: 'sn/server/alive',
};

export const serverApi = createApi({
	reducerPath: 'sn/serverApi',

	endpoints: (builder) => ({
		alive: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/sn/server/alive?${qs.stringify(body)}`,
			}),
			providesTags: [tags.alive],
		}),
	}),
});

export const {
	alive,
} = serverApi.endpoints;

export default serverApi;